<div class="p-4 overflow-auto h-[85vh]">

  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Department</h2>
    <p-button icon="pi pi-plus" label="Add Department" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table [value]="departments" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
    (onLazyLoad)="loadDepartments($event)" [loading]="loading || userLoading || campusLoading">

    <ng-template pTemplate="header">
      <tr>
        <th>Department Name</th>
        <th>Code</th>
        <th>Head of Department</th>
        <th>Contact</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-department>
      <tr>
        <td>{{ department.name }}</td>
        <td>{{ department.code }}</td>
        <td>{{ department.head_of_department || 'N/A'}}</td>
        <td>{{ department.contact_number || 'N/A'}}</td>
        <td>{{ department.status }}</td>
        <td>
          <div (click)="setDepartmentData(department)">
            <p-menu [tabindex]="undefined" #menu [model]="departmentActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="6" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="6" class="no-data-record-found">
          <p>No records found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>

<!-- Add Department Modal -->
<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-department 
      (reload)="reload()" 
      [campuses]="campuses"
      [orgId]="orgId" 
      [users]="users"
      (close)="closeAddModal()"></app-create-department>
  </p-dialog>
</ng-container>

<!-- Edit Department Modal -->
<ng-container *ngIf="showEditDepartment">
  <p-dialog [(visible)]="showEditDepartment" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-department 
      (reload)="reload()" 
      [orgId]="orgId" 
      [campuses]="campuses"
      [type]="'Update'" 
      [departmentDataToEdit]="departmentDataToEdit"
      (close)="showEditDepartment = false"></app-create-department>
  </p-dialog>
</ng-container>

<!-- Delete Department Modal -->
<ng-container *ngIf="showDeleteDepartment">
  <p-dialog [(visible)]="showDeleteDepartment" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <app-delete-department 
      [orgId]="orgId" 
      (reload)="reload()"
      [departmentDataToEdit]="departmentDataToEdit"
      (close)="showDeleteDepartment = false"></app-delete-department>
  </p-dialog>
</ng-container>
